import { http } from '@/core/helpers/http.helper';
import { Communication } from '../../communications/communication.interface';
import { ApiResource } from '../../../models/api-resource.interface';
import { Contact } from './contact.interface';
export class ContactService {
   async getContacts(customerId: number) {
      const response = await http.get<ApiResource<Array<Contact>>>(`/customers/${customerId}/contacts`);
      return response.data;
   }

   async getContact(customerId: number, contactId: number) {
      const response = await http.get<ApiResource<Contact>>(`/customers/${customerId}/contacts/${contactId}`);
      return response.data;
   }

   async postContact(customerId: number, contact: Contact) {
      const response = await http.post<ApiResource<Contact>>(`/customers/${customerId}/contacts`, contact);
      return response.data;
   }

   async putContact(customerId: number, contactId: number, contact: Contact) {
      const response = await http.put<ApiResource<Contact>>(`/customers/${customerId}/contacts/${contactId}`, contact);
      return response.data;
   }

   async deleteContact(customerId: number, contactId: number) {
      const response = await http.delete(`/customers/${customerId}/contacts/${contactId}?is_paginated=true`);
      return response.data;
   }

   async call(customerId: number, contactId: number, hitId?: number, phoneNumber?: string) {
      const response = await http.post<ApiResource<Communication>>(`/customers/${customerId}/contacts/${contactId}/call/${hitId || ''}`, {
         phone_number: phoneNumber,
      });
      return response.data;
   }

   async inviteToVideoRoom(customerId: number, videocallRoomId: number, contactId: number) {
      const response = await http.get<ApiResource<Communication>>(
         `/customers/${customerId}/contacts/${contactId}/video-room/${videocallRoomId}/invite`,
      );
      return response.data;
   }

   async searchContact(customerId: number, search: string) {
      const response = await http.get<ApiResource<Array<Contact>>>(`/customers/${customerId}/contacts`, {
         params: { search },
      });
      return response.data;
   }
}
